import { ApprovalTypes } from 'ui-product-approvals-common';
// Deals and quotes manage their approvers in their own settings, not by
// reassigning an individual approval.
export const isReassignSupportedForType = approvalType => approvalType !== ApprovalTypes.DEAL && approvalType !== ApprovalTypes.QUOTE;